import React, { Component } from 'react';

import logo from '../../../../images/LOGO_PATHE.png';
import popcorn0 from '../../../../images/POPCORN_0.png';
import popcorn1 from '../../../../images/POPCORN_1.png';
import popcorn2 from '../../../../images/POPCORN_2.png';
import popcorn3 from '../../../../images/POPCORN_3.png';
import Config from "../../../../config/config";

export default class AnswerDevice extends Component {

	constructor(props) {
		super(props);

		this.state = {
		}
		console.log("AnswerDevice:", props.result);

		// debug props.result = {totalScore: 807, score: 807.9, numberOfStars: 2}
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Answer',
			'page_path': '/answer'
		});
	}

	getThemeStyle(questionConfig) {
		let themeStyle = {};

		themeStyle.topLogoImage = questionConfig.theme_device_top_logo ? questionConfig.theme_device_top_logo : logo;
		themeStyle.bottomLogoStyle = questionConfig.theme_device_bottom_logo ? {backgroundImage: "url('" + questionConfig.theme_device_bottom_logo + "')"} : null;
		themeStyle.curtainsStyle = questionConfig.theme_device_curtains ? {backgroundImage: "url('" + questionConfig.theme_device_curtains + "')"} : null;
		themeStyle.backgroundImage = questionConfig.theme_device_background_image ? {backgroundImage: "url('" + questionConfig.theme_device_background_image + "')"} : null;
		themeStyle.signStyle = questionConfig.theme_device_answer_sign_background_image ? {backgroundImage: "url('" + questionConfig.theme_device_answer_sign_background_image + "')"} : null;
		
		themeStyle.signBackgroundImage = questionConfig.theme_device_answer_sign_background_image ? {backgroundImage: "url('" + questionConfig.theme_device_answer_sign_background_image + "')"} : null;
		
		themeStyle.scoreStyle = {};
		if (questionConfig.theme_device_answer_score_color) themeStyle.scoreStyle.color = "#" + questionConfig.theme_device_answer_score_color;

		themeStyle.screenStyle = {};
		if (questionConfig.theme_device_font) themeStyle.screenStyle.fontFamily = questionConfig.theme_device_font;
		if (questionConfig.theme_device_text_color) themeStyle.screenStyle.color = "#" + questionConfig.theme_device_text_color;
		if (questionConfig.theme_device_background_image) {
			themeStyle.screenStyle.backgroundImage = "url('" + questionConfig.theme_device_background_image + "')";
			themeStyle.screenStyle.position = "absolute";		
			themeStyle.screenStyle.height = "100vh";
			themeStyle.screenStyle.backgroundSize = "contain";
		}

		themeStyle.popcornConfig = {};
		themeStyle.popcornConfig.popcorn0 = questionConfig.theme_device_answer_popcorn_0_image ? questionConfig.theme_device_answer_popcorn_0_image : popcorn0;
		themeStyle.popcornConfig.popcorn1 = questionConfig.theme_device_answer_popcorn_1_image ? questionConfig.theme_device_answer_popcorn_1_image : popcorn1;
		themeStyle.popcornConfig.popcorn2 = questionConfig.theme_device_answer_popcorn_2_image ? questionConfig.theme_device_answer_popcorn_2_image : popcorn2;
		themeStyle.popcornConfig.popcorn3 = questionConfig.theme_device_answer_popcorn_3_image ? questionConfig.theme_device_answer_popcorn_3_image : popcorn3;

		return themeStyle;
	}

	render() {
		let themeStyle = {
			buttonStyle: {},
			screenStyle: {},
			scoreStyle: {},
			popcornConfig: {
				popcorn0: popcorn0,
				popcorn1: popcorn1,
				popcorn2: popcorn2,
				popcorn3: popcorn3
			}
		}; 
		if (this.props.question) {
			themeStyle = this.getThemeStyle(this.props.question);
		}

		const popcorns = [themeStyle.popcornConfig.popcorn0, themeStyle.popcornConfig.popcorn1, themeStyle.popcornConfig.popcorn2, themeStyle.popcornConfig.popcorn3][this.props.result.numberOfStars];
		const message = ["JAMMER!", "OKAY", "GOED!", "WOW!"][this.props.result.numberOfStars];
		const score = this.props.result.score + " PUNTEN";
		const position = this.props.result.position;
		let currentPositionDiv = null;
		if (position !== -1) {
			currentPositionDiv = <div className="userPosition">JE HUIDIGE POSITIE <span className="position">{position}</span></div>
		}
		return (
				<div className="container" style={themeStyle.screenStyle}>
					<div className="logo" ><img src={themeStyle.topLogoImage} width="100%" alt="logo" /></div>
					<div className="resultDevice">
						<div className="sign" style={themeStyle.signStyle}>
							<div className="popcorn"><img src={popcorns} style={{width:"100%"}} alt={message}/>
								<br />
								{message}
								<br />
								<div className="score" style={themeStyle.scoreStyle}>{score}</div>
							</div>
							{currentPositionDiv}
						</div>
					</div>
					<div className="curtains" style={themeStyle.curtainsStyle}></div>
				</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/components/pages/Quiz/AnswerDevice/AnswerDevice.js